import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Stethoscope, Ship, Handshake } from "lucide-react";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

const ENQUIRIES = [
    {
        id: "healthcare",
        label: "Healthcare Enquiry",
        sub: "Patients, families and medical travel",
        icon: Stethoscope,
        to: "/healthcare-enquiry",
    },
    {
        id: "trading",
        label: "Trading Enquiry",
        sub: "Buyers, suppliers and distributors",
        icon: Ship,
        to: "/trading-enquiry",
    },
    {
        id: "partnership",
        label: "Partnership Enquiry",
        sub: "Business partners and organisations",
        icon: Handshake,
        to: "/partnership-enquiry",
    },
];

export default function ContactSection() {
    const navigate = useNavigate();

    return (
        <section id="contact" className="scroll-mt-20 bg-navy-deep pb-24 pt-4 lg:pb-36" data-testid="contact-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag>Chapter 11 &mdash; Contact</ChapterTag>

                <FadeUp className="mt-8">
                    <div className="relative overflow-hidden border border-gold/25 bg-gradient-to-b from-navy-surface to-navy-deep p-8 sm:p-12 lg:p-16">
                        <div
                            className="pointer-events-none absolute -right-24 -top-24 h-[380px] w-[380px] rounded-full"
                            style={{ background: "radial-gradient(circle, rgba(197,160,89,0.14) 0%, transparent 65%)" }}
                            aria-hidden="true"
                        />
                        <SectionHead
                            eyebrow="Start Here"
                            title="Start the Right Conversation"
                            copy="Whether you are planning healthcare abroad, developing an international partnership or seeking a reliable trade connection, our team will direct your enquiry to the appropriate specialist."
                        />

                        <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
                            {ENQUIRIES.map((e) => (
                                <button
                                    key={e.id}
                                    type="button"
                                    data-testid={`enquiry-${e.id}-button`}
                                    onClick={() => navigate(e.to)}
                                    className="group relative border border-white/10 p-7 text-left transition-colors duration-500 hover:border-gold/60 hover:bg-navy-surface/60"
                                >
                                    <ArrowUpRight
                                        size={16}
                                        className="absolute right-6 top-6 text-slate-500 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold"
                                        aria-hidden="true"
                                    />
                                    <e.icon size={22} className="text-gold" aria-hidden="true" />
                                    <span className="mt-5 block font-serif text-2xl font-light text-ivory">{e.label}</span>
                                    <span className="mt-2 block text-xs uppercase tracking-[0.18em] text-slate-400">{e.sub}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
